var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-content"},[_c('div',{staticClass:"copy-btn code-data-copy",attrs:{"data-clipboard-action":"copy","data-clipboard-text":_vm.code},on:{"click":_vm.copyMessage}},[_c('i',{staticClass:"el-icon-document-copy"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-552725ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeCopy/index.vue
// module id = null
// module chunks = 